<ng-container *transloco="let t">
  @let locale = data.locale;
  <div class="flex max-h-[70vh] flex-col">
    @if (rows().length) {
      <div class="mb-4 flex justify-end">
        <app-export-button (export)="exportCsv()" />
      </div>
    }
    <div class="min-h-0 flex-1 overflow-y-auto">
      @if (rows().length) {
        <table iTable>
          <thead iTableHead>
            <tr>
              <th iTableTh>{{ t("common.account") }}</th>
              <th iTableTh>{{ t("common.marketplace") }}</th>
              <th iTableTh class="text-right">{{ t("common.keywords") }}</th>
            </tr>
          </thead>
          <tbody iTableBody>
            @for (row of rows(); track row.accountName + row.marketplace) {
              <tr iTableRow>
                <td iTableTd>{{ row.accountName }}</td>
                <td iTableTd>{{ row.marketplace }}</td>
                <td iTableTd class="text-right">{{ row.trackedKeywords | number: "1.0-0" : locale }}</td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <div class="text-muted-foreground py-4 text-center text-sm">{{ t("common.none") }}</div>
      }
    </div>

    <div
      class="text-foreground mt-4 grid grid-cols-[1fr_auto] gap-x-8 border-t border-gray-200 px-3.5 pt-4 font-semibold"
    >
      <div>{{ t("common.total") }}</div>
      <div class="text-right">
        {{ total() | number: "1.0-0" : locale }}
        @if (limit) {
          <span class="text-muted-foreground font-normal">/ {{ limit | number: "1.0-0" : locale }}</span>
        }
      </div>
    </div>
  </div>
</ng-container>
